<template>
	<section>
		<!-- 操作栏 -->
		<div class="action-bar">
			<el-button type="primary" size="small" @click="handleBatchMaintenance">{{ $t("serviceMaintenance.batchMaintenance") }}</el-button>
		</div>

		<!-- 表格 -->
		<el-table
			:data="tableData"
            v-loading="loading"
            element-loading-text="loading..."
			border
			style="width: 100%"
			:span-method="objectSpanMethod"
		>
			<el-table-column prop="customerName" :label="$t('serviceMaintenance.customerName')" min-width="120" align="center">
				<template slot-scope="scope">
					{{ scope.row.original_phone_group.name }}
				</template>
			</el-table-column>

			<el-table-column prop="phone_number" :label="$t('serviceMaintenance.customerPhone')" width="140" align="center">
				<template slot-scope="scope">
					<span class="phone-text">{{ scope.row.phone_number }}</span>
				</template>
			</el-table-column>

			<el-table-column prop="customer_id" :label="$t('serviceMaintenance.associatedRestaurantId')" min-width="150" align="center">
				<template slot-scope="scope">
					{{ scope.row.customer_id }}
				</template>
			</el-table-column>

			<el-table-column prop="restaurantName" :label="$t('serviceMaintenance.restaurantName')" min-width="160" align="center">
				<template slot-scope="scope">
					{{ scope.row.restaurant_name }}
				</template>
			</el-table-column>

			<el-table-column :label="$t('serviceMaintenance.operate')" width="200" fixed="right" align="center">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleMaintenance(scope.row)">{{ $t("serviceMaintenance.serviceMaintenance") }}</el-button>
				</template>
			</el-table-column>
		</el-table>

        <service-maintenance-batch-opertion-dialog
            :visible.sync="batchDialogVisible"
            :customerList="tableData"
            @success="handleBatchSuccess"
            @close="batchDialogVisible = false"
        />
	</section>
</template>

<script>
import ServiceMaintenanceBatchOperationDialog from "./components/service-maintenance-batch-opertion-dialog.vue";
export default {
	name: "ServiceUserList",
    components: {
    "service-maintenance-batch-opertion-dialog": ServiceMaintenanceBatchOperationDialog,
    },

	props: {
		tableData: {
			type: Array,
			default: () => [],
		},
		loading: Boolean,
		spanArr: {
			type: Array,
			default: () => [],
		},
        handleBatchSuccess: Function,

	},
	data() {
		return {
            batchDialogVisible: false,// 批量维护弹窗

		};
	},
	methods: {

        // 合并单元格
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0 || columnIndex === 1 || columnIndex === 4) {
				const _row = this.spanArr[rowIndex];
				const _col = _row > 0 ? 1 : 0;

				return {
					rowspan: _row,
					colspan: _col,
				};
			}
		},

        // 跳转维护
		handleMaintenance(row) {
			this.$router.push({
				path: `/setting/service-maintenance/${encodeURIComponent(row.phone_number)}`,
			});
		},

         // 批量维护
		handleBatchMaintenance() {

			this.batchDialogVisible = true;
		},
	},
};
</script>


<style lang="less" scoped>
.action-bar {
	margin-bottom: 16px;
	display: flex;
	justify-content: flex-end;
}
</style>